import { FC, useState, useEffect, useRef } from 'react';
import { TextField, Button } from '@mui/material';

import User from './users-management/user';
import StorylineServerProxy from './storyline-proxy/storyline-proxy';

interface UserProfileFormProps {
    username: string,
}
  

export const UserProfileForm:FC<UserProfileFormProps> = ({ username }) => {

    let [user, setUser] = useState(null as (null | User));

    let signatureRef = useRef("");

    useEffect(() => {
        StorylineServerProxy.getUser(username).then((user) => { 
            setUser(user);
            signatureRef.current.value = user.emailSignature;
        })
        .catch((error) => { alert(error)});
    }, [username]);

    function handleSubmitClicked(){
        let newUser = new User(
            user!.username,
            signatureRef?.current.value
        );

        StorylineServerProxy.updateUser(newUser);
    }

    return (
        <>
        Username: { user?.username }
        <br/><br/>
        Email signature: <TextField inputRef={signatureRef} ></TextField>
        <br/><br/>
        <Button onClick={handleSubmitClicked}>Update</Button>
        </>
    )
};